module.exports = __webpack_public_path__ + "img/hero_seller.08e766f1.png";